<template>
  <div lang="tr" class="vertical-align-step-0">
    <form method="POST" id="step0" @submit.prevent="sendForm" class="mb-4">
      <div v-for="product in selectableProducts" :key="product.id">
        <div
          @click="changeMainProduct(product)"
          class="box-border2"
          v-bind:class="{ 'selected-product': selectedMainProduct === product.id }"
        >
          <div class="box-content-field">
            <div class="pb-4 pt-4 align-self-center main-features-field-half">
              <div class="product-name-field d-flex flex-column justify-content-end">
                <div class="d-flex justify-content-between gap-3 mb-3">
                  <p class="font-weight-bold header-item mb-0">{{ product.name }}</p>
                  <div v-if="product.selectedPeriod === 'annualy'" class="card-badge align-self-center">
                    Kredi kartı ile 12 ay taksit
                  </div>
                </div>
              </div>

              <div class="d-flex period-field">
                <div
                  class="period-item clickable-item"
                  @click="changePeriod(product, 'annualy')"
                  :class="
                    product.selectedPeriod === 'annualy' && selectedMainProduct === product.id
                      ? 'selected-period'
                      : 'unselected-period'
                  "
                >
                  <div class="d-flex w-100 justify-content-between">
                    <div>
                      <p v-if="showMonthlyPackages" class="period-text mb-0">Yıllık plan</p>

                      <div v-if="isInCampaignPeriod && product.packages.annualy.discountPrice">
                        <p class="mb-0 period-price-discount">
                          {{
                            formatPrice(
                              (product.packages.annualy.net_price * 100) /
                                (100 + Number(product.packages.annualy.vat_rate)) /
                                12,
                              product.packages.annualy.currency
                            )
                          }}
                          + KDV / {{ $t('Ay') }}
                        </p>
                        <p class="mb-0 discount-price-text badge-new mt-1">
                          {{ product.packages.annualy.discountPrice }}

                          <span class="ml-1"
                            ><i
                              v-tippy="
                                'Yıllık ' +
                                formatPrice(
                                  Number(
                                    product.packages.annualy.net_price / (1 + product.packages.annualy.vat_rate / 100)
                                  ),
                                  product.packages.annualy.currency
                                ) +
                                ' yerine <span class=' +
                                'font-medium' +
                                '>' +
                                product.packages.annualy.discountPriceTotal +
                                '</span> ödeyin'
                              "
                              class="fa fa-info-circle feature-icon"
                            ></i
                          ></span>
                        </p>
                      </div>
                      <div v-else>
                        <p class="mb-0 period-price">
                          {{
                            formatPrice(
                              (product.packages.annualy.net_price * 100) /
                                (100 + Number(product.packages.annualy.vat_rate)) /
                                12,
                              product.packages.annualy.currency
                            )
                          }}
                          + KDV / {{ $t('Ay') }}
                          <span v-if="product.packages.annualy.net_price" class="ml-1"
                            ><i
                              v-tippy="
                                'Yıllık <span class=' +
                                'font-medium' +
                                '>' +
                                formatPrice(
                                  (Number(product.packages.annualy.net_price) * 100) /
                                    (100 + Number(product.packages.annualy.vat_rate)),
                                  product.packages.annualy.currency
                                ) +
                                ' + KDV </span> ödeyin'
                              "
                              class="fa fa-info-circle feature-icon"
                            ></i
                          ></span>
                        </p>
                      </div>
                    </div>
                    <div v-if="showMonthlyPackages">
                      <label class="container_radio version_2">
                        <input
                          v-model="product.selectedPeriod"
                          class="required"
                          :name="'selected-period'"
                          type="radio"
                          value="annualy"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </div>
                  </div>
                  <p
                    v-if="
                      showMonthlyPackages &&
                      product.packages.monthly &&
                      product.packages.monthly.id &&
                      !isInCampaignPeriod
                    "
                    class="mb-0 additional-text"
                  >
                    *Aylık plana göre
                    <b>{{ formatPrice(Number(getDiscountedPrice(product.packages.monthly.code)), '₺') }}</b> daha
                    hesaplı
                  </p>
                </div>

                <div
                  v-if="showMonthlyPackages && product.packages.monthly && product.packages.monthly.id"
                  class="period-item clickable-item"
                  @click="changePeriod(product, 'monthly')"
                  :class="
                    product.selectedPeriod === 'monthly' && selectedMainProduct === product.id
                      ? 'selected-period'
                      : 'unselected-period'
                  "
                >
                  <div class="d-flex w-100 justify-content-between">
                    <div>
                      <p class="period-text mb-0">Aylık plan</p>
                      <p class="period-price mb-0">
                        {{
                          formatPrice(
                            (
                              (product.packages.monthly.net_price * 100) /
                              (100 + Number(product.packages.monthly.vat_rate))
                            ).toFixed(2),
                            product.packages.monthly.currency
                          )
                        }}
                        + KDV / {{ $t('Ay') }}
                      </p>
                    </div>
                    <div>
                      <label class="container_radio version_2">
                        <input
                          v-model="product.selectedPeriod"
                          class="required"
                          :name="'selected-period'"
                          type="radio"
                          :value="'monthly'"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <article>
                <div
                  :class="
                    getAdditionalFeatures(product.packages.monthly.code).length % 2 === 0
                      ? 'even-feature'
                      : 'odd-feature'
                  "
                >
                  <ul
                    class="vertical-center features-spacing main-feature mt-4"
                    :class="product.isHaveOneLineFeatures ? 'features-full' : 'features-half'"
                  >
                    <li
                      v-for="feature in getFeatures(product.packages.annualy.code)"
                      :key="feature.text"
                      class="col-12"
                      :class="product.isHaveOneLineFeatures ? '' : 'col-md-6 '"
                    >
                      <span class="d-flex align-items-start feature-item">
                        <span v-tippy="feature.text" class="feature-text">{{ feature.text }}</span>
                        <i
                          v-if="feature.tooltipOptions"
                          v-tippy="feature.tooltipOptions.text"
                          class="fa fa-info-circle feature-icon"
                        ></i>
                      </span>

                      <div v-if="feature.subFeatures" class="subfeature-field">
                        <div v-for="subfeature in feature.subFeatures" :key="subfeature.text" class="subfeature-item">
                          <img src="/img/green-feature.svg" />
                          {{ subfeature.text }}
                          <i
                            v-if="subfeature.tooltipOptions"
                            v-tippy="subfeature.tooltipOptions.text"
                            class="fa fa-info-circle feature-icon"
                          ></i>
                        </div>
                      </div>
                    </li>
                  </ul>
                  <TransitionGroup
                    name="fade"
                    mode="out-in"
                    tag="ul"
                    appear
                    :duration="100"
                    class="vertical-center features-half additional-feature"
                  >
                    <template
                      v-if="
                        selectedMainProduct === product.id ||
                        selectedAdditionalFeature.includes(product.packages.monthly.code)
                      "
                    >
                      <li
                        v-for="feature in getAdditionalFeatures(product.packages.monthly.code)"
                        :key="feature.text"
                        class="col-md-6 col-12"
                      >
                        <span class="d-flex align-items-start feature-item">
                          <span v-tippy="feature.text" class="feature-text">{{ feature.text }}</span>
                          <i
                            v-if="feature.tooltipOptions"
                            v-tippy="feature.tooltipOptions.text"
                            class="fa fa-info-circle feature-icon"
                          ></i>
                        </span>
                      </li>
                    </template>
                  </TransitionGroup>
                  <template v-if="selectedMainProduct !== product.id">
                    <div class="w-100 d-flex justify-content-end">
                      <div class="show-more-text">
                        <span
                          v-if="getFeatures(product.packages.annualy.code).length >= 4"
                          @click.stop.prevent="toggleSelectedAdditionalFeature(product.packages.monthly.code)"
                          class="d-flex span-item"
                        >
                          {{
                            !selectedAdditionalFeature.includes(product.packages.monthly.code)
                              ? $t('Detayları Göster')
                              : $t('Detayları Gizle')
                          }}
                          <div class="arrow-field">
                            <span
                              class="arrow"
                              :class="selectedAdditionalFeature.includes(product.packages.monthly.code) ? 'active' : ''"
                            >
                              <span></span>
                              <span></span>
                            </span>
                          </div>
                        </span>
                      </div>
                    </div>
                  </template>

                  <div>
                    <div class="startup-additional-package light-blue-bg m-n3">
                      <div class="d-flex justify-content-between">
                        <div class="vertical-center">
                          <div class="text-left my-2">
                            <div class="font-weight-bold">{{ commitmentData.name }}</div>
                            <div class="m-0 d-flex align-items-center">
                              <span class="overline2">
                                <span class="font-weight-bold">{{
                                  formatPrice(
                                    Number(
                                      (commitmentData.final_price * 100) / (100 + Number(commitmentData.vat_rate))
                                    ),
                                    commitmentData.currency
                                  )
                                }}</span>
                                <span class="pale-text additional-onetime-text"> + KDV ({{ $t('Tek Sefer') }})</span>
                              </span>
                              <div class="card-badge-small align-self-center ml-2">
                                {{ $t('Ücretsiz') }}
                              </div>
                            </div>
                          </div>
                          <div>
                            <ul class="vertical-center features">
                              <li class="mb-2">{{ $t('Şirket Kuruluşu') }}</li>
                              <li class="mb-2">{{ $t('Kuruluş Danışmanlığı') }}</li>
                              <li class="mb-2">Elektronik Fatura Açılışı</li>
                              <li class="mb-2">Ön Muhasebe Programı Açılışı</li>
                            </ul>
                          </div>
                        </div>
                        <div class="text-center vertical-center product-image">
                          <img src="/img//hizli-girisimcilik.svg" class="company-type" />
                        </div>
                      </div>
                      <small class="d-block features-notes">
                        <p class="mb-3">*Oda kaydı ve noter masrafları dahil değildir.</p>
                      </small>
                      <!-- <div class="additional-msg mt-2" v-if="product.selectedPeriod === 'monthly'">
                        <small class="d-inline-block">
                          <label class="container_check version_2">
                            <small class="font-weight-bold text-center m-0">
                              <p class="mb-1" v-html="$t('register_screen.step1.aggreement_text')"></p>
                            </small>
                            <small class="d-block">
                              <p class="mb-1" v-html="$t('register_screen.step1.aggreement_sub_text')"></p>
                            </small>
                            <input
                              v-model="commitment"
                              :checked="true"
                              name="commitment"
                              type="checkbox"
                              value="true"
                            />
                            <span class="checkmark mt-2"></span>
                          </label>
                        </small>
                      </div> -->
                    </div>
                  </div>
                </div>
              </article>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import RegisterStore from '@/stores/register';
import CompanyStore from '@/stores/company';
import ProductStore from '@/stores/product';

export default {
  data() {
    return {
      main: [
        'NEW_STARTER_TR_ANNUAL',
        'STANDART_TRPACKAGE',
        'STANDART_TRPACKAGEANNUAL',
        'ADVANCE_TRPACKAGE',
        'ADVANCE_TRPACKAGEANNUAL',
        'COMMITMENT',
      ],
      products: [],
      selectableProducts: [],
      selectedAdditionalFeature: [],
      selectedMainProduct: null,
      company: null,
      commitment: true,
      commitmentData: {},
    };
  },
  computed: {
    companyTypeCode() {
      if (this.company) {
        return this.company.companyType.data.code;
      }
      return null;
    },
    isCorporate() {
      if (this.company) {
        const code = this.company.companyType.data.code;
        if (['LIMITED', 'CORPORATION'].indexOf(code) > -1) {
          return true;
        }
      }
      return false;
    },
    isLimited() {
      if (this.company) {
        const code = this.company.companyType.data.code;
        if (code === 'LIMITED') {
          return true;
        }
      }
      return false;
    },
    starterFeatures: function () {
      return [
        {
          text: 'Şirket kuruluşu',
        },
        {
          text: 'Online Muhasebe',
          tooltipOptions: {
            header: 'Online Muhasebe',
            text: 'Online muhasebe hizmeti; Mükellef teknoloji çözümleri ve uygulamalarıyla mükelleflerini yönetebilen mali müşavirler tarafından, ilgili asgari ücret tarifelerine uygun olarak verilir.',
          },
          subFeatures: [
            {
              text: 'Muhasebe Hizmeti',
              tooltipOptions: {
                header: 'Online Muhasebe',
                text: 'Online muhasebe hizmeti; Mükellef teknoloji çözümleri ve uygulamalarıyla mükelleflerini yönetebilen mali müşavirler tarafından, ilgili asgari ücret tarifelerine uygun olarak verilir.',
              },
            },
            { text: 'e-Arşiv Fatura' },
            { text: 'Fiş/Fatura Yükleme' },
            { text: 'Yıllık 100 İşlem Kaydı' },
          ],
        },
        {
          text: 'Dijital doküman erişimi',
        },
      ];
    },
    standartFeatures: function () {
      if (!this.isCorporate) {
        return this.$t('TrStandartBireyselMaddeleri');
      } else {
        return this.$t('TrStandartKurumsalMaddeleri');
      }
    },
    standartAdditionalFeatures: function () {
      if (!this.isCorporate) {
        return this.$t('TrStandartAdditionalBireyselMaddeleri');
      } else {
        return this.$t('TrStandartAdditionalKurumsalMaddeleri');
      }
    },
    advanceFeatures: function () {
      if (!this.isCorporate) {
        return this.$t('TrAdvanceBireyselMaddeleri');
      } else {
        return this.$t('TrAdvanceKurumsalMaddeleri');
      }
    },
    advanceAdditionalFeatures: function () {
      if (!this.isCorporate) {
        return this.$t('TrAdvanceAdditionalBireyselMaddeleri');
      } else {
        return this.$t('TrAdvanceAdditionalKurumsalMaddeleri');
      }
    },
    showMonthlyPackages() {
      /* if (
        this.$store.state.selfMeData.first_channel.show_monthly_packages &&
        this.$store.state.selfMeData.has_partner_link
      ) {
        return true;
      }
      return false; */
      return true;
    },
  },
  created() {
    this.startWaiting();
    CompanyStore.dispatch('getCompany').then((s) => {
      if (s.data.data.length) {
        this.company = s.data.data[0];

        if (
          this.company.buyable_packages &&
          this.company.buyable_packages.includes('NEW_STARTER_TR_ANNUAL') &&
          this.companyTypeCode !== 'SELFEMP'
        ) {
          this.selectableProducts.push({
            id: 'starter',
            name: 'Starter',
            isHaveOneLineFeatures: true,
            selectedPeriod: null,
            lastSelectedPeriod: null,
            packages: {
              monthly: {},
              annualy: {},
            },
          });
        }
        if (this.companyTypeCode !== 'SELFEMP') {
          this.selectableProducts.push({
            id: 'standart',
            name: 'Standard',
            selectedPeriod: null,
            lastSelectedPeriod: null,
            packages: {
              monthly: {},
              annualy: {
                discountPrice: !this.isCorporate
                  ? this.isInCampaignPeriod
                    ? this.formatPrice(1199, '₺') + ' + KDV / Ay'
                    : null
                  : this.isLimited
                  ? this.formatPrice(2599, '₺') + ' + KDV / Ay'
                  : this.formatPrice(3319, '₺') + ' + KDV / Ay',
                discountPriceTotal: !this.isCorporate
                  ? this.isInCampaignPeriod
                    ? this.formatPrice(14390, '₺')
                    : null
                  : this.isLimited
                  ? this.formatPrice(31190, '₺')
                  : this.formatPrice(39830, '₺'),
              },
            },
          });
        }
        this.selectableProducts.push({
          id: 'advance',
          name: 'Advanced',
          selectedPeriod: null,
          lastSelectedPeriod: null,
          packages: {
            monthly: {},
            annualy: {
              discountPrice: !this.isCorporate
                ? this.isInCampaignPeriod
                  ? this.formatPrice(1799, '₺') + ' + KDV / Ay'
                  : null
                : this.isLimited
                ? this.formatPrice(3319, '₺') + ' + KDV / Ay'
                : this.formatPrice(3879, '₺') + ' + KDV / Ay',
              discountPriceTotal: !this.isCorporate
                ? this.isInCampaignPeriod
                  ? this.formatPrice(21590, '₺')
                  : null
                : this.isLimited
                ? this.formatPrice(39830, '₺')
                : this.formatPrice(46550, '₺'),
            },
          },
        });
        this.$store.commit('setCompany', s.data.data[0]);

        this.startWaiting();

        ProductStore.dispatch('getProductsByCodes', {
          codes: this.main,
          sort: true,
          companyTypeId: this.company.company_type_id,
        }).then((s) => {
          const index = s.data.data.findIndex((x) => x.code === 'COMMITMENT');
          this.commitmentData = s.data.data[index];
          // this.commitment = this.company.package === null || !this.company.package.includes('COMMITMENT');
          s.data.data.splice(index, 1);
          this.products = s.data.data;
          this.selectableProducts.forEach((element) => {
            const products = this.products.filter(({ code }) => code.includes(element.id.toUpperCase()));
            const index = products.findIndex((object) => {
              return object.period !== 'annual';
            });
            if (index !== -1) {
              element.packages.monthly = { ...element.packages.monthly, ...products[index] };
              products.splice(index, 1);
            }
            element.packages.annualy = { ...element.packages.annualy, ...products[0] };
          });

          let selectedProduct;
          if (this.company.package) {
            this.company.package.forEach((element) => {
              if (this.products.find((e) => e.code === element)) {
                const id = element.split('_')[0];
                const findData = this.selectableProducts.find((e) => e.id.toUpperCase() === id);
                if (findData) {
                  selectedProduct = findData.id;
                  if (element.includes('ANNUAL')) {
                    findData.selectedPeriod = 'annualy';
                    findData.lastSelectedPeriod = 'annualy';
                  } else {
                    findData.selectedPeriod = 'monthly';
                    findData.lastSelectedPeriod = 'monthly';
                  }
                }
              }
            });
          }
          if (!selectedProduct && this.selectableProducts.length > 0) {
            const isStarterSelectable = this.selectableProducts.find((product) => product.id === 'starter');
            selectedProduct = isStarterSelectable ? 'starter' : this.selectableProducts[0].id;
          }
          this.selectedMainProduct = selectedProduct;

          if (!this.selectableProducts.filter(({ selectedPeriod }) => selectedPeriod).length) {
            this.selectableProducts[0].selectedPeriod = 'annualy';
            this.selectableProducts[0].lastSelectedPeriod = 'annualy';
          }

          this.endWaiting();
        });
      }
    });
  },
  methods: {
    getDiscountedPrice(code) {
      const isStandardCode = code && code.includes('STANDART');
      const prices = {
        OPERATION: isStandardCode ? '13200' : '15600',
        SELFEMP: isStandardCode ? '18000' : '15600',
        LIMITED: isStandardCode ? '24000' : '30000',
        CORPORATION: isStandardCode ? '24000' : '32400',
      };
      return prices[this.companyTypeCode];
    },
    changePeriod(product, data) {
      product.selectedPeriod = data;
      product.lastSelectedPeriod = data;
    },
    getFeatures(code) {
      if (code) {
        if (code.includes('STARTER')) {
          return this.starterFeatures;
        } else if (code.includes('STANDART')) {
          return this.standartFeatures;
        } else {
          return this.advanceFeatures;
        }
      }
      return [];
    },
    getAdditionalFeatures(code) {
      if (code) {
        if (code.includes('STARTER')) {
          return [];
        } else if (code.includes('STANDART')) {
          const product = this.selectableProducts.find(({ id }) => id === this.selectedMainProduct);
          if (
            this.isCorporate &&
            product &&
            product.selectedPeriod === 'annualy' &&
            !this.standartAdditionalFeatures.find(({ text }) => text.toLowerCase() === 'e-Defter'.toLowerCase())
          ) {
            return [
              ...this.standartAdditionalFeatures,
              {
                text: this.$t('E-Defter'),
                tooltipOptions: {
                  text: this.$t('e-Defter Tooltip'),
                },
              },
            ];
          }
          return this.standartAdditionalFeatures;
        } else {
          return this.advanceAdditionalFeatures;
        }
      }
      return [];
    },

    toggleSelectedAdditionalFeature(code) {
      const index = this.selectedAdditionalFeature.indexOf(code);
      if (index > -1) {
        this.selectedAdditionalFeature.splice(index, 1);
      } else {
        this.selectedAdditionalFeature.push(code);
      }
    },
    changeMainProduct(product) {
      if (product.id !== this.selectedMainProduct) {
        this.selectedMainProduct = product.id;
        product.selectedPeriod = product.lastSelectedPeriod;
        const products = this.selectableProducts.filter(({ id }) => id !== this.selectedMainProduct);
        products.forEach((element) => {
          element.selectedPeriod = null;
        });
      }
      if (!product.selectedPeriod) {
        product.selectedPeriod = 'annualy';
        product.lastSelectedPeriod = 'annualy';
      }
    },
    sendForm(callback) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (!this.selectedMainProduct) {
            this.$toasted.error(this.$t('AlertMessages.Lütfen bir ürün seçin'));
            return;
          }

          this.startWaiting();
          const packageData = [];
          if (this.selectedMainProduct) {
            const selectedData = this.selectableProducts.find((e) => e.id === this.selectedMainProduct);
            packageData.push(selectedData.packages[selectedData.selectedPeriod].code);
            if (selectedData.selectedPeriod !== 'annualy') {
              if (!this.commitment) {
                packageData.push(this.commitmentData.code);
              }
            }
          }

          RegisterStore.dispatch('package', {
            packages: packageData,
            companyNationId: 1,
          }).then((s) => {
            if (s.data.success === false) {
              this.$toasted.error(this.$t('AlertMessages.Lütfen bir ürün seçin'));
              this.endWaiting();
              return;
            }
            this.$store.commit('setCompanyId', s.data.data.id);
            callback();
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.box-content-field {
  padding: 0px 0px 0px 0px;
  color: #4b5563;
  flex-wrap: wrap;

  .show-more-text {
    font-weight: bold;
    font-size: 12px;
    letter-spacing: -0.01em;
    line-height: 24px;
    cursor: pointer;
    color: #222222;
    transition: color 0.15s ease-in-out;

    .span-item {
      justify-content: end;
    }
  }
  .show-more-text:hover {
    color: black;
  }

  .container_radio.version_2 {
    padding: 6px 0 0 33px !important;
  }

  .period-field {
    gap: 24px;
    .period-item {
      position: relative;
      padding: 16px 12px;
      flex: 1;
      border: 1px solid;
      border-radius: 16px;
      .period-text {
        font-size: 14px;
        font-weight: 600;
        line-height: 24px;
        letter-spacing: -0.02em;
      }
      .period-price {
        font-size: 16px;
        font-weight: 700;
        line-height: 24px;
        letter-spacing: -0.02em;
      }
      &.selected-period {
        border-color: #00aa6b;
        box-shadow: 0px 0px 0px 2px #e0f5ed;
      }
      &.unselected-period {
        border-color: #ececec;
        box-shadow: none;
      }
    }
    @media (max-width: 520px) {
      flex-direction: column;
      min-height: 110px;
    }
  }

  .header-item {
    font-size: 20px;
    line-height: 40px;
    color: black !important;
  }

  .price-item {
    color: #222222 !important;
    font-size: 16px;
    line-height: 24px;
    font-weight: 500;
    letter-spacing: -0.02em;
  }

  .main-features {
    font-size: 15px;
  }
  .features-spacing {
    margin-top: 1rem;
  }

  .subfeature-field {
    background: #f9f9f9;
    border-radius: 4px;
    color: #4b4b4b;
    padding: 8px;
    display: flex;

    justify-content: space-between;
    gap: 4px;
    margin-top: 4px;
    flex-direction: row;
    @media (max-width: 1100px) {
      flex-direction: column;
      align-items: flex-start;
    }
    @media (max-width: 992px) {
      flex-direction: row;
      align-items: center;
    }
    @media (max-width: 576px) {
      flex-direction: column;
      align-items: flex-start;
    }
  }

  .subfeature-item {
    display: flex;
    align-items: flex-start;
    font-size: 12px;
    line-height: 24px;
    img {
      width: 16px;
      margin-right: 2px;
      margin-top: 4px;
    }
    i {
      margin-left: 6px;
      margin-top: 5px;
    }
  }

  .even-feature .additional-feature li:not(:nth-last-of-type(-n + 2)) {
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  }
  .odd-feature .additional-feature li:not(:nth-last-of-type(-n + 1)) {
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  }

  .features-half,
  .features-full,
  .features-additional-half {
    display: flex;
    flex-wrap: wrap;

    li {
      .feature-item {
        flex-flow: wrap;
        .feature-text {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          margin-right: 0.5rem;
        }
      }

      @media (max-width: 576px) {
        flex-basis: 100%;
        max-width: 100%;
      }
    }
  }
}

.card-badge {
  background: #00aa6b;
  color: white;
  border-radius: 53px;
  padding: 4px 12px;
  line-height: 32px;
  letter-spacing: -0.02em;
  font-size: 12px;
}

.card-badge-small {
  background: #00aa6b;
  color: white;
  border-radius: 53px;
  padding: 3px 15px;
  line-height: 20px;
  letter-spacing: -0.02em;
  font-size: 12px;
}

.additional-text {
  font-size: 12px;
  line-height: 20px;
  font-weight: 500;
  margin-top: 6px;
  color: #00aa6b;
  letter-spacing: -0.02em;
}

.arrow-field {
  width: 30px;
  transform: scale(0.6);
  text-align: center;
  border: black;
  .arrow {
    span {
      background: black;
    }
  }
}
</style>
